import { render } from "./GameDetails.vue?vue&type=template&id=34eb3894&scoped=true"
import script from "./GameDetails.vue?vue&type=script&lang=js"
export * from "./GameDetails.vue?vue&type=script&lang=js"

import "./GameDetails.vue?vue&type=style&index=0&id=34eb3894&scoped=true&lang=css"
import "./GameDetails.vue?vue&type=style&index=1&id=34eb3894&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.31_vue@3.4.31_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34eb3894"]])

export default __exports__